import { render, staticRenderFns } from "./ProductTabs.vue?vue&type=template&id=8044499c&scoped=true&"
import script from "./ProductTabs.vue?vue&type=script&lang=js&"
export * from "./ProductTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabs.vue?vue&type=style&index=0&id=8044499c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8044499c",
  null
  
)

export default component.exports